import React from 'react'

import Routing, { SideMenu } from '../../components/reusable/routing'

import Summary from './summary'
import EligibleOrders from './eligibleOrders'

const menu = [
    {
        path: '',
        title: 'Summary',
        component: Summary
    },
    {
        path: 'eligible-orders',
        title: 'Eligible Orders',
        component: EligibleOrders
    },
]

const CreditControl = () => {
    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto flex flex-no-wrap max-h-full overflow-hidden">
            <div className="w-1/6 overflow-y-scroll">
                <p className="text-2xl font-semibold">Credit Control</p>
                <SideMenu namespace="credit-control" menu={ menu } />
            </div>
            <div className="w-5/6 overflow-y-scroll">
                <Routing namespace="credit-control" menu={ menu } />
            </div>
        </div>
    )
}

export default CreditControl
